export const boy = Object.freeze([
  "boy_1",
  "boy_2",
  "boy_3",
  "boy_4",
  "boy_5",
  "boy_6",
  "boy_7",
  "boy_8",
  "boy_9",
  "boy_10",
  "boy_11",
  "boy_12",
  "boy_13",
  "boy_14",
  "boy_15",
  "boy_16",
  "boy_17",
  "boy_18",
  "boy_19",
  "boy_20",
  "boy_21",
  "boy_22",
  "boy_23",
  "boy_24",
  "boy_25",
  "boy_26",
  "boy_27",
  "boy_28",
  "boy_29",
  "boy_30",
  "boy_31",
  "boy_32",
  "boy_33",
  "boy_34",
  "boy_35",
]);

export const girl = Object.freeze([
  "girl_1",
  "girl_2",
  "girl_3",
  "girl_4",
  "girl_5",
  "girl_6",
  "girl_7",
  "girl_8",
  "girl_9",
  "girl_10",
  "girl_11",
  "girl_12",
  "girl_13",
  "girl_14",
  "girl_15",
  "girl_16",
  "girl_17",
  "girl_18",
  "girl_19",
  "girl_20",
  "girl_21",
  "girl_22",
  "girl_23",
  "girl_24",
  "girl_25",
  "girl_26",
  "girl_27",
  "girl_28",
  "girl_29",
  "girl_30",
  "girl_31",
  "girl_32",
  "girl_33",
  "girl_34",
  "girl_35",
]);

export const other = Object.freeze([
  "other_1",
  "other_2",
  "other_3",
  "other_4",
  "other_5",
  "other_6",
  "other_7",
  "other_8",
]);
